import { render, staticRenderFns } from "./UserEditAvatarUpload.vue?vue&type=template&id=43cebcd4&scoped=true&"
import script from "./UserEditAvatarUpload.vue?vue&type=script&lang=js&"
export * from "./UserEditAvatarUpload.vue?vue&type=script&lang=js&"
import style0 from "./UserEditAvatarUpload.vue?vue&type=style&index=0&id=43cebcd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cebcd4",
  null
  
)

export default component.exports